import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/_app/runs/$id/workspace")({
  parseParams: (params) => {
    return { id: z.coerce.number().parse(params.id) };
  },
  validateSearch: (search) => {
    return z
      .object({
        tab: z.string().prefault("overview"),
        day: z.coerce.number().nullable().prefault(null),
      })
      .parse(search);
  },
});
